// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import PromotionCodePage from './PromotionCodePage.container';
import I18n from '../../../../../lib/i18n';
import theme from '../../../../../theme-config';
import { FullScreenModal, TertiaryFullButton } from '../../../../../components/common';

export default class PromotionCodeButtonWithModal extends Component<Props> {
  closePromotionCodeModal = () => this.props.setPromotionCodeModalVisible(false);
  openPromotionCodeModal = () => this.props.setPromotionCodeModalVisible(true);
  render() {
    const styles = getStyles();
    return (
      <View>
        <TertiaryFullButton
          text={I18n.t('SignUp.ConfirmPlan.promotionCode.link')}
          style={styles.promotionCodeLink}
          onPress={this.openPromotionCodeModal}
        />
        <FullScreenModal visible={this.props.isModalVisible} onRequestClose={this.closePromotionCodeModal}>
          <PromotionCodePage onRequestClose={this.closePromotionCodeModal} />
        </FullScreenModal>
      </View>
    );
  }
}

type Props = {
  isModalVisible: boolean,
  setPromotionCodeModalVisible: (isModalVisible: boolean) => void,
};

const getStyles = () =>
  StyleSheet.create({
    promotionCodeLink: {
      fontSize: 16,
      color: theme.signUpTextColor,
    },
  });
